/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/megaphone_medium'
export default icon
